var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDownloadIcon = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "#264D6D",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.498.007c-.369.05-.652.372-.652.76L7.845 10.91 5.211 8.225c-.295-.3-.773-.3-1.068 0-.294.3-.294.783 0 1.083l3.923 4c.144.146.335.225.534.225s.39-.079.534-.225l3.923-4c.294-.3.294-.783 0-1.083l-.085-.074c-.295-.224-.715-.199-.983.074l-2.637 2.687L9.354.767C9.354.344 9.017 0 8.6 0l-.102.007zM16.446 14.667H.754c-.417 0-.754.343-.754.766s.337.767.754.767h15.692c.417 0 .754-.344.754-.767 0-.423-.337-.766-.754-.766z",
    transform: "translate(-1352 -95) translate(1065.58 85) translate(286.42) translate(0 10)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download-icon.eadbcf9c.svg";
export { ForwardRef as ReactComponent };